import { createContext } from "react";
const defaultPrefetchHooksContext = ()=>{
    return Promise.resolve({});
};
export const PrefetchHooksContext = /*#__PURE__*/ createContext(defaultPrefetchHooksContext);

//# sourceMappingURL=PrefetchHooksContext.js.map